import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { ProgrammeCards } from './types';
import { formatMoney, formatNumber, formatPercent } from './format';

type Props = { cards: ProgrammeCards | null };

const ProgrammeCardsPanel: React.FC<Props> = ({ cards }) => {
  const items = [
    ['Total Activities', formatNumber(cards?.totalactivities)],
    ['New', formatNumber(cards?.newactivities)],
    ['Maintained', formatNumber(cards?.maintainedactivities)],
    ['Abandoned', formatNumber(cards?.abandonedactivities)],
    ['Initial Budget', formatMoney(cards?.initialbudget)],
    ['Revised Budget', formatMoney(cards?.revisedbudget)],
    ['Variance', formatMoney(cards?.varianceamount)],
    ['Variance %', formatPercent(cards?.variancepercent)],
    ['Missing Fields', formatNumber(cards?.missingfields)],
  ];

  return (
    <Grid container spacing={2}>
      {items.map(([label, value]) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={label}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">{label}</Typography>
              <Typography variant="h5" sx={{ mt: 1, fontWeight: 700 }}>{value}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProgrammeCardsPanel;
